import React from "react";
import { Accordion } from "semantic-ui-react";
import Segment from "semantic-ui-react/dist/commonjs/elements/Segment";
import { viewerRoleConfigEnabledDBs } from "../../../../config/config";
import { AclResource } from "../../../../types/acl";
import { FineGrainedPermission, Permission } from "../../../../types/permissions";
import { Role as RoleType } from "../../../../types/roles";
import { exists } from "../../../../utils/utils";
import Resource from "./Resource";

type RoleComponentProps = {
  onChange: (change: any) => any;
  permissions: Permission[];
  fineGrainedPermissions: FineGrainedPermission[];
  canEdit: boolean;
  role: RoleType;
  regionDB?: string;
};

class Role extends React.PureComponent<RoleComponentProps> {
  resources = this.props.permissions.reduce<AclResource[]>(
    (resources, permission) =>
      exists(resources.find(resource => resource.id === permission.resourceId)) ||
      !permission.aclResource
        ? resources
        : resources.concat(permission.aclResource),
    []
  );

  resourcesPanelsForRole = (role: RoleType) => (
    <Accordion style={{ minWidth: "300px" }} key={role.id} exclusive={false}>
      {this.resources.map(resource => (
        <Resource
          canEdit={
            role.code === "URBANCANVAS_VIEWER" &&
            ["charts", "layers", "layers_attributes", "base_data_collections"].includes(
              resource.code
            ) &&
            this.props.regionDB !== undefined &&
            viewerRoleConfigEnabledDBs.includes(this.props.regionDB) &&
            this.props.canEdit
          }
          key={role.id + resource.id}
          onChange={this.props.onChange}
          role={this.props.role}
          resource={resource}
          permissions={this.props.permissions}
          fineGranularity={this.props.role.aclRolesFineGrainedResourcesActions}
          fineGrainedPermissions={this.props.fineGrainedPermissions}
        />
      ))}
    </Accordion>
  );

  render() {
    return (
      <Segment style={{ margin: "5px" }} key={this.props.role.id}>
        <h3>{this.props.role.name}</h3>
        {this.resourcesPanelsForRole(this.props.role)}
      </Segment>
    );
  }
}

export default Role;
